import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'procure-ai-badge',
  template: 'AI',
  styleUrl: './ai-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AIBadge {}
